export default __webpack_public_path__ + "static/media/1040.6bfa4e35.png";